export default function replaceFullWidthCharacters(v) {
  let str = v;
  if (str == null) {
    str = '';
  }
  let value = '';
  const fullWidth = '\uff10\uff11\uff12\uff13\uff14\uff15\uff16\uff17\uff18\uff19';
  const halfWidth = '0123456789';
  const chars = str.split('');

  for (let i = 0, len = chars.length; i < len; i += 1) {
    let char = chars[i];
    const idx = fullWidth.indexOf(char);
    if (idx > -1) {
      char = halfWidth[idx];
    }
    value += char;
  }
  return value;
}
